import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { AccountModulesPayload } from 'types/account/accountModules';

export type AccountModulesState = {
  data: AccountModulesPayload | null;
  isLoading: boolean;
  isLoaded: boolean;
  hasError: boolean;
};

const initialState: AccountModulesState = {
  data: null,
  isLoading: false,
  isLoaded: false,
  hasError: false,
};

const accountModulesSlice = createSlice({
  name: 'accountModules',
  initialState,
  reducers: {
    setAccountModulesLoading(state) {
      state.isLoading = true;
      state.hasError = false;
    },
    setAccountModulesSuccess(state, action: PayloadAction<AccountModulesPayload>) {
      state.data = action.payload;
      state.isLoading = false;
      state.isLoaded = true;
      state.hasError = false;
    },
    setAccountModulesError(state) {
      state.isLoading = false;
      state.isLoaded = true;
      state.hasError = true;
    },
    incrementMessagesQuotaUsed(state, action: PayloadAction<number | undefined>) {
      const count = Math.max(1, Math.floor(action.payload ?? 1));
      const quota = state.data?.messagesQuota;
      if (!quota) return;

      quota.remaining = Math.max(0, quota.remaining - count);
      quota.used = Math.min(quota.limit, quota.limit - quota.remaining);
    },
    resetAccountModules() {
      return initialState;
    },
  },
});

export default accountModulesSlice.reducer;
export const {
  setAccountModulesLoading,
  setAccountModulesSuccess,
  setAccountModulesError,
  incrementMessagesQuotaUsed,
  resetAccountModules,
} = accountModulesSlice.actions;
